.container {
  gap: var(--mirai-ui-space-XS);
}

.container > *:not(:last-child) {
  margin-bottom: calc(var(--mirai-ui-input-text-padding-y) / 2);
}
